import React from "react";

import icon from "./icon.svg";

function CloudyIcon({ className }: { className: string }) {
  return <img className={className} src={icon} alt="Cloudy" />;
}

export { CloudyIcon };
